<!-- Shown INSTEAD of the app when the viewport is too small to continue on.
     See DeviceGateService for when that is, and why the live class is the one
     route gated even for a signed-in user. -->
<div class="dg">
  <img src="/assets/svg/logo.svg" alt="Miles Education" class="dg-brand" />

  <div class="dg-card">
    <!-- A browser window being pulled open. Shown only for "small-window":
         the monitor-and-tablet art below says "use one of these", which
         contradicts a message whose whole point is that their device is fine. -->
    <svg class="dg-art" *ngIf="(reason$ | async) === 'small-window'"
      viewBox="0 0 120 72" fill="none" xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true">
      <rect x="26" y="14" width="68" height="44" rx="4" stroke="currentColor" stroke-width="3" />
      <path d="M26 26h68" stroke="currentColor" stroke-width="3" />
      <circle cx="34" cy="20" r="1.8" fill="currentColor" />
      <circle cx="41" cy="20" r="1.8" fill="currentColor" />
      <!-- arrows pulling the frame outward -->
      <path d="M16 36h-12M4 36l5-5M4 36l5 5" stroke="currentColor" stroke-width="3"
        stroke-linecap="round" stroke-linejoin="round" />
      <path d="M104 36h12M116 36l-5-5M116 36l-5 5" stroke="currentColor" stroke-width="3"
        stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <!-- A desktop monitor and a tablet, to say "these two" without words. -->
    <svg class="dg-art" *ngIf="(reason$ | async) !== 'small-window'"
      viewBox="0 0 120 72" fill="none" xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true">
      <rect x="2" y="6" width="78" height="48" rx="4" stroke="currentColor" stroke-width="3" />
      <path d="M30 62h22M41 54v8" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
      <rect x="88" y="20" width="30" height="46" rx="4" stroke="currentColor" stroke-width="3" />
      <path d="M99 60h8" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
    </svg>

    <img src="/assets/caira_ready/cairaLogo.svg" alt="CAIRA" class="dg-caira" />

    <!-- ===== Right machine, wrong window size =====
         Deliberately first: this student is ALREADY on a tablet or desktop, so
         the two blocks below are not only useless to them, they are why people
         got stuck. -->
    <ng-container *ngIf="(reason$ | async) === 'small-window'; else deviceCopy">
      <!-- One `as vp` for the whole block: shortSide() below needs it too, and
           scoping it to a single <p> left it undefined everywhere else. -->
      <ng-container *ngIf="viewport$ | async as vp">
      <h1 class="dg-title">Make this window a little bigger</h1>

      <p class="dg-body">
        Your computer is fine — this browser window is just too small for the
        LMS to lay out properly. Drag it {{ shortSide(vp) }}, or maximise it, and
        this will disappear on its own.
      </p>

      <p class="dg-size">
        <span class="dg-size-now">{{ vp.width }} × {{ vp.height }}</span>
        <span class="dg-size-arrow" aria-hidden="true">→</span>
        <span class="dg-size-need">{{ minWidth }} × {{ minHeight }} needed</span>
      </p>

      <p class="dg-body dg-body--muted">
        Still seeing this on a full-screen window? Your browser is probably
        zoomed in — press <kbd class="dg-kbd">Ctrl</kbd> +
        <kbd class="dg-kbd">0</kbd> (<kbd class="dg-kbd">⌘</kbd> +
        <kbd class="dg-kbd">0</kbd> on a Mac) to reset it.
      </p>
      </ng-container>
    </ng-container>

    <ng-template #deviceCopy>
    <!-- ===== Live class: signed in, but this route needs a real screen ===== -->
    <ng-container *ngIf="(reason$ | async) === 'live-class'; else signInCopy">
      <h1 class="dg-title">Join the live class from a tablet or desktop</h1>

      <p class="dg-body">
        Live sessions need a real screen — the video, the slides and the polls
        won't fit on a phone. We've kept you out rather than let you join as a
        name in the attendee list with nothing you can actually see.
      </p>

      <p class="dg-body dg-body--muted">
        Open <a class="dg-url" [href]="siteUrl">{{ siteUrlDisplay }}</a> on a
        tablet or computer and join from your webinar there. You're still signed
        in.
      </p>
    </ng-container>

    <!-- ===== Pre-login: the general case ===== -->
    <ng-template #signInCopy>
      <h1 class="dg-title">Open this on a tablet or desktop</h1>

      <p class="dg-body">
        The Miles CAIRA LMS is built for larger screens — live sessions, labs and
        the course player all need the room. Your phone can't show them properly,
        so we've stopped you here rather than after you sign in.
      </p>

      <!-- A real <a>, not plain text: on a phone that makes it long-pressable,
           so the address can be copied or shared straight to another device. -->
      <p class="dg-body dg-body--muted">
        Open <a class="dg-url" [href]="siteUrl">{{ siteUrlDisplay }}</a> on a
        tablet or computer to sign in and pick up where you left off.
      </p>
    </ng-template>
    </ng-template>
  </div>
</div>
